import usePageMeta from "utils/usePageMeta";
/* eslint-disable no-unused-vars */

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Layout
import SubPageLayout from "reusables/layouts/SubPageLayout";

// Sections
import Office_Section1 from "./sections/Office_Section1";
import Office_Section2 from "./sections/Office_Section2";
import Office_Section3 from "./sections/Office_Section3";
import Office_Section4 from "./sections/Office_Section4";
import Office_Section5 from "./sections/Office_Section5";
import Office_Section6 from "./sections/Office_Section6";

function OfficeCleaning() {
  usePageMeta({
    title: "Office Cleaning Services Ireland | Spechs",
    description:
      "Professional office cleaning for businesses across Ireland. Clean, healthy, productive workspaces.",
    canonical: "https://www.spechs.ie/cleaning/office/",
  });
  return (
    <SubPageLayout title="Office Cleaning">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Office_Section1 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Office_Section2 />
      </MKBox>
      {/* <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Office_Section3 />
      </MKBox> */}
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Office_Section4 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Office_Section5 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Office_Section6 />
      </MKBox>
    </SubPageLayout>
  );
}

export default OfficeCleaning;
